import { boolValOrUndef, nbVal, nbValOrUndef, strValOrUndef } from "@paroi/data-formatters-lib";

export interface Reference {
  id: number;
  code?: string;
  name?: string;
  description?: string;
  dataSource?: string;
  enabled: boolean;
  databaseGenerated: boolean;
  databaseName?: string;
  organization?: Organization;
  lineNumber: number;
  columnNumber: number;
  createdAt?: string;
}

export interface GeneratedReference extends Reference {
  enabled: true;
  databaseGenerated: true;
}

export interface Organization {
  id: number;
  acronym?: string;
  name?: string;
  enabled: boolean;
  logo?: string;
  ownerName?: string;
  ownerEmail?: string;
  phone?: string;
  address?: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
}

export function formatToReference(data: unknown): Reference {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid data");
  }
  const validData = data as Record<string, unknown>;
  return {
    id: nbVal(validData.id),
    code: strValOrUndef(validData.code),
    name: strValOrUndef(validData.name),
    description: strValOrUndef(validData.description),
    dataSource: strValOrUndef(validData.data_source),
    enabled: boolValOrUndef(validData.enabled) ?? false,
    databaseGenerated: boolValOrUndef(validData.database_generated) ?? false,
    databaseName: strValOrUndef(validData.database_name),
    createdAt: strValOrUndef(validData.created_at),
    organization: formatOrganization(validData.organization),
    lineNumber: nbValOrUndef(validData.line_number) ?? 0,
    columnNumber: nbValOrUndef(validData.column_number) ?? 0,
  };
}

export function formatFromReferenceToGeneratedReference(
  reference: Reference,
): GeneratedReference | undefined {
  if (!reference.enabled || !reference.databaseGenerated) return;
  return {
    ...reference,
    enabled: true,
    databaseGenerated: true,
  };
}

export function formatToGeneratedReference(
  data: unknown | Reference,
): GeneratedReference | undefined {
  const reference = formatToReference(data);
  if (!reference.enabled || !reference.databaseGenerated) return;
  return reference as GeneratedReference;
}

function formatOrganization(data: any): Organization | undefined {
  if (!data || !data.id) return;
  if (typeof data !== "object" || Array.isArray(data)) {
    throw new Error("Invalid organization data");
  }
  return {
    id: nbVal(data.id),
    name: strValOrUndef(data.name),
    acronym: strValOrUndef(data.acronym),
    logo: strValOrUndef(data.logo),
    enabled: boolValOrUndef(data.enabled) ?? false,
    address: strValOrUndef(data.address),
    ownerName: strValOrUndef(data.owner_name),
    ownerEmail: strValOrUndef(data.owner_email),
    phone: strValOrUndef(data.phone),
    description: strValOrUndef(data.description),
    createdAt: strValOrUndef(data.created_at),
    updatedAt: strValOrUndef(data.updated_at),
    deletedAt: strValOrUndef(data.deleted_at),
  };
}
